<div class="layout-topbar">
  <div class="layout-topbar-logo-container">
    <button
      class="layout-menu-button layout-topbar-action"
      (click)="layoutService.onMenuToggle()"
    >
      <i class="pi pi-bars"></i>
    </button>
    <a class="layout-topbar-logo" routerLink="/">
      <p-avatar image="assets/principal/logo-mini.png" class="mr-2" />
      <span class="topbar-brand">Pampa</span>
    </a>
  </div>

  <div class="layout-topbar-actions">
    <button type="button" class="layout-topbar-action monitoring-action" (click)="abrirMonitoreo()" aria-label="Ver errores del aplicativo">
      <i class="pi pi-bell"></i>
      <span *ngIf="erroresPendientes > 0" class="monitoring-badge">{{ erroresPendientes > 99 ? '99+' : erroresPendientes }}</span>
    </button>
    <div class="layout-config-menu">
      <button
        type="button"
        class="layout-topbar-action"
        (click)="toggleDarkMode()"
      >
        <i
          [ngClass]="{
            'pi ': true,
            'pi-moon': layoutService.isDarkTheme(),
            'pi-sun': !layoutService.isDarkTheme()
          }"
        ></i>
      </button>
    </div>
    <span class="topbar-user-name">{{ usuario?.nombreCompleto || usuario?.nombreUsuario }}</span>
  </div>
</div>
